import type { PlataformaDePublicacaoDto } from "@base/contracts";
import { cn } from "@base/ui";
import { LogoX } from "./logo-x";
import {
  LogoFacebook,
  LogoInstagram,
  LogoTikTok,
} from "./logos-redes";

export const ROTULO_PLATAFORMA: Record<PlataformaDePublicacaoDto, string> = {
  instagram: "Instagram",
  facebook: "Facebook",
  twitter: "X",
  tiktok: "TikTok",
};

export const ROTULO_PLATAFORMA_CURTO: Record<
  PlataformaDePublicacaoDto,
  string
> = {
  instagram: "IG",
  facebook: "FB",
  twitter: "X",
  tiktok: "TikTok",
};

type TomDoIcone = "sucesso" | "falha" | "neutro";

type Props = {
  readonly plataforma: PlataformaDePublicacaoDto;
  readonly className?: string;
  /** Texto acessível; default = nome da rede. */
  readonly titulo?: string;
  readonly tom?: TomDoIcone;
};

/**
 * Ícone monócromo da rede (currentColor) para agenda e seletores.
 */
export function IconePlataforma({
  plataforma,
  className,
  titulo,
  tom = "neutro",
}: Props) {
  const rotulo = titulo ?? ROTULO_PLATAFORMA[plataforma];
  const classe = cn(
    "size-3.5",
    tom === "sucesso" && "text-success",
    tom === "falha" && "text-destructive",
    className,
  );

  const icone =
    plataforma === "instagram" ? (
      <LogoInstagram className={classe} />
    ) : plataforma === "facebook" ? (
      <LogoFacebook className={classe} />
    ) : plataforma === "twitter" ? (
      <LogoX className={classe} />
    ) : (
      <LogoTikTok className={classe} />
    );

  return (
    <span
      className="inline-flex shrink-0 items-center justify-center"
      title={rotulo}
      aria-label={rotulo}
    >
      {icone}
    </span>
  );
}
